import { countries, countryCodes } from '@modules/internationalisation/country';
import { countryCodeFromString } from '@modules/internationalisation/country';
import { AUDCountries, Canada, countryGroups, EURCountries, GBPCountries, International, NZDCountries, UnitedStates, } from '@modules/internationalisation/countryGroup';
import * as cookie from 'helpers/storage/cookie';
import { getQueryParameter } from 'helpers/urls/url';
export class Country {
    static codeFromString(search) {
        const candidateIso = search.toUpperCase();
        if (candidateIso === 'UK') {
            return 'GB';
        }
        return countryCodeFromString(candidateIso) ?? null;
    }
    static findCountryCode(country) {
        if (!country) {
            return null;
        }
        return (this.codeFromString(country) ??
            countryCodes.find((key) => countries[key] === country) ??
            null);
    }
    static fromCountryGroup(countryGroupId = null) {
        switch (countryGroupId) {
            case UnitedStates:
                return 'US';
            case Canada:
                return 'CA';
            default:
                return null;
        }
    }
    static fromPath(path = window.location.pathname) {
        if (path === '/us' || path.startsWith('/us/')) {
            return 'US';
        }
        else if (path === '/ca' || path.startsWith('/ca/')) {
            return 'CA';
        }
        return null;
    }
    static fromQueryParameter() {
        const country = getQueryParameter('country');
        if (country) {
            return this.codeFromString(country);
        }
        return null;
    }
    static fromCookie() {
        const country = cookie.get('GU_country');
        if (country) {
            return this.codeFromString(country);
        }
        return null;
    }
    static fromGeolocation() {
        const country = cookie.get('GU_geo_country');
        if (country) {
            return this.codeFromString(country);
        }
        return null;
    }
    static fromOldGeolocation() {
        return this.findCountryCode(window.guardian.geoip?.countryCode);
    }
    static setCountry(country) {
        cookie.set('GU_country', country, 7);
    }
    static handleCountryForCountryGroup(targetCountryGroup, countryGroupId = null) {
        const paths = {
            International: ['/int', '/int/'],
            EURCountries: ['/eu', '/eu/'],
            NZDCountries: ['/nz', '/nz/'],
            GBPCountries: ['/uk', '/uk/'],
            AUDCountries: ['/au', '/au/'],
        };
        const defaultCountry = {
            International: 'IN',
            EURCountries: 'DE',
            NZDCountries: 'NZ',
            GBPCountries: 'GB',
            AUDCountries: 'AU',
        };
        const path = window.location.pathname;
        if (path !== paths[targetCountryGroup][0] &&
            !path.startsWith(paths[targetCountryGroup][1] ?? '') &&
            countryGroupId !== targetCountryGroup) {
            return null;
        }
        const candidateCountry = this.fromQueryParameter() ?? this.fromCookie() ?? this.fromGeolocation();
        if (candidateCountry &&
            countryGroups[targetCountryGroup].countries.includes(candidateCountry)) {
            return candidateCountry;
        }
        return defaultCountry[targetCountryGroup];
    }
    static detect(countryGroupId = null) {
        const targetCountryGroups = [
            International,
            EURCountries,
            NZDCountries,
            GBPCountries,
            AUDCountries,
        ];
        let country = null;
        for (const targetCountryGroupId of targetCountryGroups) {
            const candidateCountry = this.handleCountryForCountryGroup(targetCountryGroupId, countryGroupId);
            if (candidateCountry !== null) {
                country = candidateCountry;
                break;
            }
        }
        if (country === null) {
            country =
                this.fromCountryGroup(countryGroupId) ??
                    this.fromPath() ??
                    this.fromQueryParameter() ??
                    this.fromCookie() ??
                    this.fromGeolocation() ??
                    this.fromOldGeolocation() ??
                    'GB';
        }
        this.setCountry(country);
        return country;
    }
}
